export const getFileUploadQuota = {
  pathname: '/vt_upload_status',
}

export const getUsers = {
  pathname: '/vt_service_accounts'
}
